// AI-CONTEXT: See docs/features/participation-ladder.md
// Model parameters for the participation-ladder monetarisation, taken from the
// "Parameters arbeidsparticipatie" sheet of Meetstandaard Social Impact v1.0.
// calculateParticipationState accepts a parameters argument, so a per-tenant
// override could be added later without changing the calculation.

const defaultParticipationParameters = {
    weeksPerYear: 52,
    volunteerValuePerHour: 10,

    // Progressive income-tax brackets (belastingafdracht). Each bracket taxes
    // the income between the previous ceiling and `upTo` at `rate`.
    taxBrackets: [
        { upTo: 38883, rate: 0.3575 },
        { upTo: 78426, rate: 0.3756 },
        { upTo: Infinity, rate: 0.495 },
    ],

    // Gross personal income per year by education level x hours band
    // (CBS "Gemiddeld persoonlijk inkomen, bruto € per jaar, 2024").
    incomeByEducationAndHoursBand: {
        'Geen startkwalificatie': {
            'minder dan 12 uur per week': 7800,
            '12 tot 20 uur per week': 15000,
            '20 tot 35 uur per week': 29000,
            'Voltijd': 50400,
        },
        'MBO 2-4/havovwo': {
            'minder dan 12 uur per week': 15000,
            '12 tot 20 uur per week': 19300,
            '20 tot 35 uur per week': 35600,
            'Voltijd': 56300,
        },
        'HBO/WO': {
            'minder dan 12 uur per week': 29700,
            '12 tot 20 uur per week': 30200,
            '20 tot 35 uur per week': 50900,
            'Voltijd': 79600,
        },
    },

    // Yearly benefit cost (negative = cost to society).
    benefitAmountPerYear: {
        Bijstandsuitkering: -18768, // -1564 * 12
        'WAO/WIA/WAZ/WAJONG': -21123,
    },

    // Uitvoeringskosten van een bijstandsuitkering: wat de gemeente kwijt is aan
    // het uitvoeren zelf, en dus bespaart zodra iemand de bijstand verlaat.
    //
    // TELT MEE IN DE MAATSCHAPPELIJKE WAARDE. De Meetstandaard publiceert dit als
    // eersteklas parameter naast benefitAmountPerYear, met bronvermelding
    // (gemeente.nu, "Uitvoering bijstand kost bijna EUR 2.900 per uitkering").
    // Hier stond eerder dat het "geen onderdeel van de kernberekening" was — dat
    // sloeg op het Output-blad van het oorspronkelijke spreadsheet, niet op de
    // gepubliceerde parameterset, en heeft twijfel gezaaid die er niet hoort.
    // Bevestigd tegen de live parameters-API op 2026-08-25 (versie 2026.1).
    bijstandUitvoeringskostenPerYear: -2900,

    // Welke uitkering een gedeeltelijk deel (benefitShare) kent. Alleen bijstand:
    // het WAO/WIA/WAZ/WAJONG-bedrag is een UWV-gemiddelde dat gedeeltelijke
    // uitkeringen al bevat. Gelijk aan benefitRules in parameterset 2026.2 van de
    // Meetstandaard API; hier zodat ook een 2026.1-payload de regel kent.
    benefitRules: {
        shareAppliesTo: ['Bijstandsuitkering'],
    },
}

export default defaultParticipationParameters
